import { savePaymentFetchType } from "containers/DeclarationPage/utils";
import { fetchPaymentsBetweenDates } from "store/paymentSlice";
import { useAppDispatch } from "store/store";
import type { IDatesRange } from "types";

import useAPIPagination from "./useAPIPagination";

/**
 * Refetches data for Payment page so that it's all updated when an action is performed.
 * Actions can be: updating title price, updating term channels, updating beneficiary, deleting advance or beneficiary.
 */
export default function usePaymentStateUpdate(dateRange: IDatesRange) {
    const dispatch = useAppDispatch();
    const { handleRequest } = useAPIPagination({ type: undefined });

    /**
     * Refetches data in Payment page when an element (advance/term/title/beneficiary) changes or a new payment is created.
     */
    const updatePaymentPageState = async () => {
        handleRequest({
            defaultType: "paymentsHistory",
            extraOptions: {
                dates: { startDate: dateRange.startDate, endDate: new Date() },
                paymentLot: undefined,
                sortOrder: "desc",
                limit: 10,
            },
        });
        handleRequest({
            defaultType: "paymentLots",
            extraOptions: { paymentLot: undefined, sortOrder: "desc", limit: 10 },
        });
        await dispatch(
            fetchPaymentsBetweenDates({
                startDate: new Date(dateRange.startDate).toLocaleDateString("en-CA"),
                endDate: new Date().toLocaleDateString("en-CA"),
            }),
        ),
            savePaymentFetchType("payments");
    };

    return { updatePaymentPageState };
}
